module.exports = __webpack_public_path__ + "img/03_orange_dance.e6f573e6.gif";